import Helpers from "./modules/helpers";
import fastdom from "fastdom";

declare var $: any;
declare var Mustache: any;
declare var LC_API: any;

var site = {

	doc: $(document),
	win: $(window),
	body: $('body'),
	html: $('html'),
	transitionSpeed: 300,
	touchFlag: false,
	activeSiteSetting: document.body.getAttribute("data-active-site-setting"),

	modernizrIsTouch: function () {
		// modernizr was removed in BR-1204, touch test was extracted from modernizr to keep behaviour
		// @ts-ignore
		return "ontouchstart" in document || <any>window.DocumentTouch && document instanceof DocumentTouch;
	},

	detectTouch: function () {
		// touch flags
		var touchTest1 = site.modernizrIsTouch(),
			touchTest2 = (typeof navigator.maxTouchPoints !== 'undefined') ? navigator.maxTouchPoints : false;

		site.touchFlag = (touchTest1 || touchTest2) ? true : false;

		fastdom.mutate(() => {
			site.html.addClass(touchTest1 ? 'touch' : 'no-touch');
		});
	},

	preInit: function () {
		site.stopInstagramError();
		site.detectTouch();
		// standalone
		site.standalone();
		// userNav
		site.userNav();
		// support
		site.detectNoHover();
		fastdom.mutate(() => {
			site.detectDefaultFontSize();
		});
		site.detectInteractionMediaQuerySupport();
		// instant page
		site.instantPageLinks();
		site.openLiveChat();
		site.disableFooterNewsletterInput();

		// debug font
		//setTimeout(function () {
		//	site.debugFontWeight();
		//}, 2000);
		// init
		site.init();
	},

	init: function () {
		site.smoothScroll();
		site.forms.init();
		site.cms.init();
	},

	debugFontWeight: function () {

		var allElements = document.querySelectorAll('*');

		for (var i = 0; i < allElements.length; i++) {
			var compStyles = window.getComputedStyle(allElements[i]);
			var fontWeight = compStyles.getPropertyValue('font-weight');

			if (fontWeight === "400") {
				continue;
			}

			allElements[i].classList.add('u-debug');
			console.log(allElements[i], fontWeight);
		}

	},

	// Stop Instagram browser flooding logs with "Can't find variable: _AutofillCallbackHandler" exceptions
	stopInstagramError: function() {
		(<any>window)._AutofillCallbackHandler = (<any>window)._AutofillCallbackHandler || function () { }
	},

	standalone: function () {
		// lets links open in standalone window instead of safari
		//@ts-ignore
		if (('standalone' in window.navigator) && window.navigator.standalone) {
			var noddy, remotes = false;
			document.addEventListener('click', function (event) {
				noddy = event.target;
				while (noddy.nodeName !== 'A' && noddy.nodeName !== 'HTML') {
					noddy = noddy.parentNode;
				}
				if ('href' in noddy && noddy.href.indexOf('http') !== -1 && (noddy.href.indexOf(document.location.host) !== -1 || remotes)) {
					event.preventDefault();
					document.location.href = noddy.href;
				}
			}, false);
		}
	},

	userNav: function () {

		var utils = $('.js-header-utils'),
		items = $('.js-header-utils-item'),
		hoverClass = 'c-header__utils__item--hovering',
		limit = '(min-width:980px)';

		if (!utils.length) return;

		items.hover(
			function () {
				if (!site.modernizrIsTouch() && window.matchMedia(limit).matches) {
					fastdom.mutate(() => {
						$(this).addClass(hoverClass);
					});
				}
			},
			function () {
				if (!site.modernizrIsTouch() && window.matchMedia(limit).matches) {
					fastdom.mutate(() => {
						$(this).removeClass(hoverClass);
					});
				}
			}
		);

		items.find('a').on('click', function () {

			var listItem = $(this).parent();

			if (site.modernizrIsTouch() && window.matchMedia(limit).matches) {

				fastdom.mutate(() => {

					listItem.toggleClass(hoverClass);

				});

				return false;
			}

		});

		$(window).on('resize', function () {

			fastdom.mutate(() => {
				items.removeClass(hoverClass);
			});

		});

	},
	smoothScroll: function () {
		$('a[href*="#"]:not(.scrollDone):not(.js-tooltip-trigger):not(.js-ignore-scroll):not(.js-print):not(.js-skip-link)').each(function () {
			var link = $(this);
			link.on('click', function () {
				if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
					var target = $(this.hash);
					target = target.length <= 1 && target || $('[name=' + this.hash.slice(1) + ']');
					if (target.length) {
						var targetOffset = target.offset().top;
						if ($(window).scrollTop != targetOffset) {
							$('html, body').animate({ scrollTop: targetOffset }, (site.transitionSpeed * 2));
						}
						return false;
					}
				}
			});
			// done
			link.addClass('scrollDone');
		});
	},

	forms: {

		init: function () {
			site.forms.adapters();
			site.forms.disabled();
			site.forms.submit();
			site.forms.autocomplete.init();
			site.forms.maxlength();
			site.forms.rating();
			site.forms.showIf();
			site.forms.captcha();
			site.forms.scrollToFormMessages();
		},

		adapters: function () {

			$.validator.unobtrusive.adapters.addBool("mandatory", "required");

			$.validator.addMethod('filesize', function (value, element, param) {
				var maxFileSize = parseInt(element.getAttribute('data-max-upload-size'));
				var isValid = true;
				var totalBytes = 0;
				for (var index = 0; index < element.files.length; index++) {
					var file = element.files[index];
					totalBytes += file.size;
				}
				if (totalBytes > maxFileSize) {
					isValid = false;
				}
				return this.optional(element) || isValid;
			}, function (params, element) {
				var maxFileSize = parseInt(element.getAttribute('data-max-upload-size'));
				var sizeInMB = (maxFileSize / (1024 * 1024)).toFixed(2);
				return 'Total file size must be less than ' + sizeInMB + 'MB';
			});

			$.validator.unobtrusive.adapters.add('requiredif', ['dependentproperty', 'dependentvalue', 'pattern'], function (options) {
				options.rules['requiredif'] = options.params;
				if (options.message) {
					options.messages['requiredif'] = options.message;
				}
			});

			$.validator.addMethod('requiredif', function (value, element, params) {

				var dependentName = params.dependentproperty;

				if (element.closest('.js-address-lookup')) {
					dependentName = "AddressViewModel." + params.dependentproperty;
				}

				var dependentValue = $(element).closest('form').find('[name="' + dependentName + '"]').val();
				if (dependentValue == params.dependentvalue) {
					var regex = new RegExp(params.pattern.replaceAll("^(?i)", "^"), "i");

					// JavaScript doesn't like the C# regex pattern for postcodes, so we need to check if the element is a postcode and tweak the regex to remove case insensitivity
					if ($(element).attr('name').toLowerCase().indexOf('postcode') > -1) {
						regex = new RegExp(params.pattern.replaceAll("^(?i)", "^"), "i");
					} else {
						regex = new RegExp(params.pattern);
					}
					return regex.test(value);
				}
				return true;
			});

		},

		disabled: function () {
			$('a.disabled, button.disabled, input.disabled').off('click.site.disabled').on('click.site.disabled', function () {
				return false;
			});
		},

		submit: function () {

			// click functionality
			$('form:not(.formDone)').each(function () {
				var wrapper = $(this);
				var win = $(window);
				// submit
				wrapper.on('submit', function () {
					// reset the validator
					wrapper.removeData('validator');
					wrapper.removeData('unobtrusiveValidation');
					// selects are hidden by the jquery chosen plugin but we need to include them in the validation
					$.validator.setDefaults({ ignore: ":hidden:not(select)" });
					// validate the form
					$.validator.unobtrusive.parse(wrapper);
					// add custom rules
					site.forms.addFilesizeRule();
				});
				// done
				wrapper.addClass('formDone');
			});

			// autosubmit functionality
			$('form[data-autosubmit="true"]:not(.formAutoDone)').each(function () {
				var wrapper = $(this);
				// get all elements that can autosubmit the form
				wrapper.find('[data-autosubmit="true"]').on('change', function () {
					wrapper.submit();
				});
				// done
				wrapper.addClass('formAutoDone');
			});
		},

		autocomplete: {

			init: function () {
				site.forms.autocomplete.simple();
				site.forms.autocomplete.products();
			},

			simple: function () {
				if ($('div#autocomplete').length < 1) {
					$('body').append('<div id="autocomplete" />')
				}
				$('input[data-autocomplete]:not(.autocompleteDone,.addressLookup)').each(function () {
					var input = $(this);
					var url = input.attr('data-autocomplete');
					// autocomplete
					input.autocomplete({
						minLength: 2,
						source: url,
						appendTo: '#autocomplete',
						open: function () {
							if (site.win.width() < 1420) {
								$('#autocomplete .ui-menu').width(340);
							}
						},
						select: function (event, ui) {
							window.location.href = ui.item.Url;
						},
						create: function () {
							$(this).data('ui-autocomplete')._renderItem = function (ul, item) {
								return $("<li>")
									.append("<a>" + item.DisplayName + "</a>")
									.appendTo(ul);
							};
						}
					}).attr('autocomplete', 'off');
					// resize
					site.win.resize(function () {
						input.autocomplete('close');
					});
					// done
					input.addClass('autocompleteDone');
				});
			},

			products: function () {
				if ($('div#autocompleteProducts').length < 1) {
					$('body').append('<div id="autocompleteProducts" />')
				}
				$('input[data-autocomplete-products]:not(.autocompleteProductsDone)').each(function () {
					var input = $(this);
					var url = input.attr('data-autocomplete-products');

					// autocomplete
					input.autocomplete({
						minLength: 3,
						source: url,
						position: { at: "left-120px top+100%" },
						appendTo: '#autocompleteProducts',
						select: function (e, ui) {
							location.href = ui.item.Url;
							return false;
						}
					}).attr('autocomplete', 'off').data('ui-autocomplete')._renderItem = function (ul, item) {
						// add class to ui
						ul.addClass('autocomplete-products');
						// get template and render for output
						var tmp = $(item.Template).html();
						Mustache.parse(tmp);
						// return html markup
						return $(Mustache.render(tmp, item))
							.data('item.autocomplete', item)
							.appendTo(ul);
					};

					// resize
					site.win.resize(function () {
						input.autocomplete('close');
					});

					// done
					input.addClass('autocompleteProductsDone');
				});
			}

		},

		maxlength: function () {
			// limit input and textarea
			$('input[data-maxlength]:not(.maxlengthDone), textarea[data-maxlength]:not(.maxlengthDone)').each(function () {
				var input = $(this);
				var count = input.parent().find('.count');
				// get limit
				var limit = parseInt(input.attr('data-maxlength'), 10);
				// limit on keyup, click or blur
				input.on('keyup click blur', function () {
					var remaining = limit - input.val().length;
					if (remaining <= 0) {
						input.val(input.val().substr(0, limit));
						remaining = 0;
					}
					count.text(remaining);
				}).blur();
				// done
				input.addClass('maxlengthDone');
			});
		},

		addFilesizeRule: function () {
			if ($('[data-max-upload-size]').length) {
				$('[data-max-upload-size]').rules("add", {
					filesize: true
				});
			}
		},

		rating: function () {
			$('.formRadiosRating:not(.ratingDone)').each(function () {
				var wrapper = $(this);
				var inputs = wrapper.find('input[type="radio"]');
				var start = inputs.filter(':checked').val();
				// set
				function set(val) {
					if (typeof val == 'undefined') val = 0;
					val = parseInt(val, 10);
					if (isNaN(val) || val < 1 || val > 5) val = 0;
					// highlight
					inputs.each(function () {
						var input = $(this);
						var label = input.closest('label');
						label.removeClass('hover');
						if (input.val() <= val) {
							label.addClass('hover');
						}
					});
				}
				// load
				set(start);
				// rollover
				inputs.closest('label').hover(
					function () {
						var input = $(this).find('input[type="radio"]');
						set(input.val());
					},
					function () {
						set(start);
					}
				);
				// click
				inputs.on('change', function () {
					start = parseInt($(this).val(), 10);
				});
				// done
				wrapper.addClass('ratingDone');
			});
		},

		showIf: function () {

			// checks
			$('.formChecks[data-show-if] input[data-show-if]:checkbox:not(.showIfDone)').each(function () {
				var input = $(this);
				var reverse = input.attr('data-reverse') == 'true' ? true : false;
				var ref = input.attr('data-show-if').split(',');
				function check() {
					if (!input.is(':checked') && reverse) {
						// show
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).show();
						}
					}
					else if (input.is(':checked') && reverse) {
						// hide
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).hide();
						}
					}
					else if (input.is(':checked')) {
						// show
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).show();
						}
					}
					else {
						// hide
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).hide();
						}
					}
				}
				// on change
				input.on('change', function () {
					check();
				});
				// on init
				check();
				// done
				input.addClass('showIfDone');
			});

			$('.formRadios[data-show-if]:not(.showIfDone)').each(function () {
				var wrapper = $(this);

				// input functionality
				wrapper.find('input').each(function () {
					var input = $(this);
					var group = input.attr('name');

					// on change
					input.on('change', function () {
						// hide non-selected
						$('input[name="' + group + '"][data-show-if]:not(:checked)').each(function () {
							var opt = $(this);
							var ref = opt.attr('data-show-if').split(',');
							// hide
							for (var i = 0; i < ref.length; i++) {
								$(ref[i]).hide();
								$(ref[i]).find('input, select').attr("disabled", "disabled");
							}
						});
						// show selected
						$('input[name="' + group + '"][data-show-if]:checked').each(function () {
							var opt = $(this);
							var ref = opt.attr('data-show-if').split(',');
							// show
							for (var i = 0; i < ref.length; i++) {
								$(ref[i]).show();
								$(ref[i]).find('input, select').removeAttr("disabled");
								$(ref[i]).find('input, select').each(function () {
									if ($(this).attr("checked") === "checked") {
										$(this).prop("checked", true);
									}
								});
							}
						});

					});

					// on load
					if (input.is('[data-show-if]:checked')) {
						var opt = $(this);
						var ref = opt.attr('data-show-if').split(',');
						// show
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).show();
							$(ref[i]).find('input, select').removeAttr("disabled");
						}
					}
					if (input.is('[data-show-if]:not(:checked)')) {
						var opt = $(this);
						var ref = opt.attr('data-show-if').split(',');
						// show
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).hide();
							$(ref[i]).find('input, select').attr("disabled", "disabled");
						}
					}

				});

				// done
				wrapper.addClass('showIfDone');
			});

			// selects
			$('select[data-show-if]:not(.showIfDone)').each(function () {
				var select = $(this);
				// on change
				select.on('change', function () {
					// hide non-selected
					select.find('option[data-show-if]:not(:selected)').each(function () {
						var opt = $(this);
						var ref = opt.attr('data-show-if').split(',');
						// hide
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).hide();
						}
					});
					// show selected
					var selected = select.find('option[data-show-if]:selected');
					selected.each(function () {
						var opt = $(this);
						var ref = opt.attr('data-show-if').split(',');
						// show selected
						for (var i = 0; i < ref.length; i++) {
							$(ref[i]).show();
						}
					});
				});
				// on init
				select.find('option[data-show-if]:selected').each(function () {
					var opt = $(this);
					var ref = opt.attr('data-show-if').split(',');
					// show selected
					for (var i = 0; i < ref.length; i++) {
						$(ref[i]).show();
					}
				});
				// done
				select.addClass('showIfDone');
			});

		},

		captcha: function () {
			$('.formCaptcha:not(.recaptchaDone)').each(function () {
			});
		},

		scrollToFormMessages: function () {
			if ($('.js-scroll-to-form-messages').find('.formError').is(":visible")) {
				window.scrollTo(0, $('.js-scroll-to-form-messages').offset().top);
			}
		}

	},

	cms: {

		init: function () {
			site.cms.images();
			site.cms.tables();
		},

		images: function () {
			$('.cms img:not(.cmsImgDone)').each(function () {
				var img = $(this);
				img.removeAttr('style', 'width', 'height');
				// done
				img.addClass('cmsImgDone');
			});
		},

		tables: function () {
			// click row tables
			$('table tr.clickRow:not(.clickRowDone)').each(function () {
				var row = $(this);
				var link = row.attr('data-link');
				// row click functionality
				row.find('*').on('click', function () {
					if (typeof link != 'undefined' && link != '') {
						window.location.href = link;
					}
				});
				// done
				row.addClass('clickRowDone');
			});
			// cms tables
			$('.cms table:not(.cmsTableDone):not(.blank)').each(function () {
				var table = $(this);
				table.wrap('<div class="tableWrapper" />');
				// done
				table.addClass('cmsTableDone');
			});
		}

	},

	detectNoHover: function () {

		if (matchMedia('(hover: none)').matches) {
			fastdom.mutate(() => {
				site.html.addClass('matchmedia-no-hover');
			});
		}

	},

	detectDefaultFontSize: function () {
		const htmlTag = document.documentElement;
		const storageKey = "site:defaultFontSize";
		let fontSizeStr = sessionStorage.getItem(storageKey);
		if (!fontSizeStr) {
			fontSizeStr = window.getComputedStyle(htmlTag).fontSize;
			sessionStorage.setItem(storageKey, fontSizeStr);
		}
		const defaultFontSize = parseFloat(fontSizeStr);
		if (defaultFontSize > 16) {
			htmlTag.classList.add('has-scaled-up-text');
			if (defaultFontSize > 23) {
				htmlTag.classList.add('has-scaled-up-text-large');
			}
		}
	},

	detectInteractionMediaQuerySupport: function () {

		if (!matchMedia('(hover)').matches && !matchMedia('(hover: none)').matches) {
			fastdom.mutate(() => {
				site.html.addClass('interaction-media-query-not-supported');
			});
		} 

	},

	getKeyPressed: function (e) {

		if (e.key !== undefined) return e.key; else if (e.keyIdentifier !== undefined) return e.keyIdentifier; else if (e.keyCode !== undefined) return e.keyCode;

	},

	debounce: function (func, wait, immediate) {

		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};

	},

	instantPageLinks: function () {
		const linksToMakerInstantPage = document.querySelectorAll('.js-instant-page-links a');

		Helpers.scopedLoop(linksToMakerInstantPage, (link: HTMLElement, i: Number, context: any) => {
			fastdom.mutate(() => {
				link.setAttribute('data-instant', '');
			});
		}, this);

	},

	openLiveChat: function () {
		var liveChatLinks = document.querySelectorAll('.js-open-live-chat');
		for (var i = 0; i < liveChatLinks.length; i++) {
			liveChatLinks[i].addEventListener("click", function (e) {
				if (typeof LC_API !== "undefined") {
					e.preventDefault();
					LC_API.open_chat_window();
				}
				
			});
		}
	},

	disableFooterNewsletterInput: function () {
		const newsletterInput = document.querySelector('.js-newsletter-signup__input');
		if (newsletterInput) {
			newsletterInput.setAttribute('disabled', 'true');
			setTimeout(() => {
				newsletterInput.removeAttribute('disabled');
			}, 500);
		}
	}

};

export default site;
